module.exports = __webpack_public_path__ + "static/media/bbb-pool-table-pricing.86e70784.png";